import React, {useState, useEffect } from 'react';
import paciente from '../api';
import {Grid, Card, CardHeader, CardContent, CardActions, TextField, Button, InputLabel, Select, MenuItem, Tooltip, IconButton} from '@material-ui/core';
import Swal from "sweetalert2";
import { differenceInYears } from 'date-fns';
import TabelaPacientes from "./Elements/TabelaPacientes";
import InputMask from "react-input-mask";

const Main = ({children}) => {
    //declarando os estados do formulario
    const [formValues, setFormValues] = useState({
        name: '',
        email: '',
        cpf: '',
        rg: '',
        genero: 'Selecione', // definindo um valor padrão diferente de ""
        cns: '',
        data_nascimento: '',
        idade: '',
        preferencial: '0',
        doenca_id: '',
        tipo_usuario_id: 1,
        tipo_deficiencia_id: 1,
        tipo_atendimento_id: 1,
    });

    //defini os estados dos erros no código
    const [error, setError] = useState(false);
    //define as constantes de doença
    const [doencas, setDoencas] = useState([]);
    //adiciona a constante da tabela
    const [tableKey, setTableKey] = useState(0); // add key to table component
    //use efect de doenças
    useEffect(() => {
        const fetchData = async () => {
            try {
                Swal.fire({
                    title: 'Carregando...',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading();
                    }
                });
                const response = await paciente.get('/tipodoencas',{timeout: 5000} );
                if(response != null){
                    Swal.close();
                    setDoencas(response.data.data);
                }

            } catch (error) {
                console.log('erro em pacientes');
            }
        };

        fetchData();
    }, []);

    //define os handelers de doenças
    const handleOptionChange = event => {
        setFormValues({
            ...formValues,
            doenca_id: event.target.value
        });
    };

    //calcula da data de nascimetno
    const calcularIdade = (dataNascimento) => {
        if (!dataNascimento) {
            return '';
        }

        const dataNascimentoFormatada = new Date(dataNascimento);
        const dataAtual = new Date();

        return differenceInYears(dataAtual, dataNascimentoFormatada);
    };


    function validateFields() {
        if (formValues.name === '') {
            return false;
        }
        if (formValues.email === '') {
            return false;
        }
        if (formValues.cpf === '') {
            return false;
        }
        if (formValues.rg === '') {
            return false;
        }
        if (formValues.genero === '') {
            return false;
        }
        if (formValues.data_nascimento === '') {
            return false;
        }
        if (formValues.idade === '') {
            return false;
        }
        if (formValues.cns === '') {
            return false;
        }
        if (formValues.tipo_atendimento_id === '') {
            return false;
        }
        return true;
    }

    //método para realizar a adição de uma nova unidade no banco de dados
//método para realizar a adição de uma nova unidade no banco de dados
    const handleSubmit = async (event) => {
        event.preventDefault();

        //recupera o token
        const token = localStorage.getItem('token');

        const isValid = validateFields();
        setError(!isValid);

        if (isValid) {
            try {
                console.log(formValues);

                const response = await paciente.post('/paciente', formValues, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });

                await Swal.fire({
                    icon: 'success',
                    title: 'Sucesso!',
                    text: response.data.message,
                });

                // refresh table component by updating its key
                setTableKey(tableKey + 1);
            } catch (error) {
                Swal.fire({
                    icon: 'error',
                    title: 'Erro!',
                    text: error.response.data.error,
                });
            }
        }
    }

    return (
        <main style={{marginLeft: '250px', padding: '20px'}}>
            {children}
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <Card>
                        <form onSubmit={handleSubmit}>
                            <CardHeader title="Cadastro de pacientes"/>
                            <CardContent>
                                <Grid container spacing={3}>
                                    <Grid item xs={5}>
                                        <InputLabel style={{padding: '0.5rem'}}>Nome do paciente</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="outlined-required"
                                            size="small"
                                            variant="outlined"
                                            placeholder="Nome do paciente"
                                            value={formValues.name.toUpperCase()} // Aplicação da função toUpperCase()
                                            onChange={(event) =>
                                                setFormValues({
                                                    ...formValues,
                                                    name: event.target.value,
                                                })
                                            }
                                            error={error}
                                            helperText={error ? 'Nome do paciente deve ser preenchido.' : ''}
                                        />
                                    </Grid>

                                    <Grid item xs={3}>
                                        <InputLabel style={{padding: '0.5rem'}}>E-mail</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="outlined-required"
                                            size="small"
                                            variant="outlined"
                                            placeholder="E-mail"
                                            type={"email"}
                                            value={formValues.email}
                                            onChange={(event) =>
                                                setFormValues({
                                                    ...formValues,
                                                    email: event.target.value,
                                                })
                                            }
                                            error={error}
                                            helperText={error ? 'O nome do paciente deve ser preenchido.' : ''}

                                        />
                                    </Grid>



                                    <Grid item xs={2}>
                                        <InputLabel style={{padding: '0.5rem'}}>CPF</InputLabel>
                                        <InputMask
                                            mask="999.999.999-99"
                                            value={formValues.cpf}
                                            onChange={(event) =>
                                                setFormValues({
                                                    ...formValues,
                                                    cpf: event.target.value,
                                                })}>
                                            {() => (
                                                <TextField
                                                    fullWidth
                                                    id="cpf"
                                                    placeholder="CPF"
                                                    variant="outlined"
                                                    size="small"
                                                    error={error}
                                                    helperText={error ? 'O cpf do paciente deve ser preenchido.' : ''}
                                                />
                                            )}
                                        </InputMask>
                                    </Grid>

                                    <Grid item xs={2}>
                                        <InputLabel style={{padding: '0.5rem'}}>RG</InputLabel>
                                        <InputMask
                                            mask="999.999.999-9"
                                            value={formValues.rg}
                                            onChange={(event) =>
                                                setFormValues({
                                                    ...formValues,
                                                    rg: event.target.value,
                                                })}>
                                            {() => (
                                                <TextField
                                                    fullWidth
                                                    id="rg"
                                                    placeholder="RG"
                                                    variant="outlined"
                                                    size="small"
                                                    error={error}
                                                    helperText={error ? 'O rg do paciente deve ser preenchido.' : ''}
                                                />
                                            )}
                                        </InputMask>
                                    </Grid>

                                    <Grid item xs={2}>
                                        <InputLabel style={{ padding: '0.5rem' }}>Sexo</InputLabel>
                                        <Select
                                            fullWidth
                                            id="outlined-required"
                                            size="small"
                                            style={{height: '40.1px'}} // adicione esta linha
                                            value={formValues.genero}
                                            onChange={(event) =>
                                                setFormValues({
                                                    ...formValues,
                                                    genero: event.target.value,
                                                })
                                            }
                                            variant="outlined"
                                            error={error}
                                            displayEmpty
                                        >
                                            <MenuItem value="Selecione">Selecione</MenuItem>
                                            <MenuItem value="masculino">Masculino</MenuItem>
                                            <MenuItem value="feminino">Feminino</MenuItem>
                                        </Select>
                                        {error && <span style={{ color: 'red' }}>O Sexo deve ser selecionado.</span>}
                                    </Grid>


                                    <Grid item xs={2}>
                                        <InputLabel style={{ padding: '0.5rem' }}>Data de Nascimento</InputLabel>
                                        <TextField
                                            fullWidth
                                            mask="99/99/9999"
                                            id="outlined-required"
                                            type="date"
                                            size="small"
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            variant="outlined"
                                            value={formValues.data_nascimento}
                                            onChange={(event) =>
                                                setFormValues({
                                                    ...formValues,
                                                    data_nascimento: event.target.value,
                                                })
                                            }
                                            onBlur={(event) =>
                                                setFormValues({
                                                    ...formValues,
                                                    idade: calcularIdade(event.target.value),
                                                })
                                            }
                                            error={error}
                                            helperText={error ? 'A data de nascimento deve ser selecionada.' : ''}
                                        />

                                    </Grid>

                                    <Grid item xs={1}>
                                        <InputLabel style={{padding: '0.5rem'}}>Idade</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="outlined-required"
                                            variant="outlined"
                                            placeholder="Idade"
                                            size="small"
                                            inputProps={{maxLength: 7}} // adiciona o atributo maxlength diretamente no input
                                            value={formValues.idade}
                                            disabled={true}
                                            onChange={(event) =>
                                                setFormValues({
                                                    ...formValues,
                                                    idade: event.target.value,
                                                })
                                            }
                                        />
                                    </Grid>
                                    <Grid item xs={3}>
                                        <Tooltip title="Carteira Nacional de Saúde" placement="right">
                                            <InputLabel style={{ padding: '0.5rem' }}>CNS</InputLabel>
                                        </Tooltip>

                                        <InputMask
                                            mask="999.9999.9999.9999"
                                            value={formValues.cns}
                                            onChange={(event) =>
                                                setFormValues({
                                                    ...formValues,
                                                    cns: event.target.value,
                                                })
                                            }
                                        >
                                            {() => (
                                                <TextField
                                                    fullWidth
                                                    id="cs"
                                                    placeholder="CNS"
                                                    variant="outlined"
                                                    size="small"
                                                    error={error}
                                                    helperText={error ? 'O número do Cartão Nacional de Saúde deve ser preenchido.' : ''}
                                                />
                                            )}
                                        </InputMask>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <InputLabel style={{ padding: '0.5rem' }}>Tipo atendimento</InputLabel>
                                        <Select
                                            fullWidth
                                            id="outlined-required"
                                            style={{height: '40.1px'}} // adicione esta linha
                                            value={formValues.preferencial}
                                            onChange={(event) =>
                                                setFormValues({
                                                    ...formValues,
                                                    preferencial: event.target.value,
                                                })
                                            }
                                            variant="outlined"
                                            error={error}
                                            displayEmpty
                                        >
                                            <MenuItem value="0">Selecione</MenuItem>
                                            <MenuItem value="Emergencial">Emergencial</MenuItem>
                                            <MenuItem value="Preferencial">Preferencial</MenuItem>
                                            <MenuItem value="Comum">Comum</MenuItem>
                                        </Select>
                                        {error && <span style={{ color: 'red' }}>O tipo de atendimento do paciente deve ser devidamente preenchido.</span>}
                                    </Grid>
                                    <Grid item xs={2}>
                                        <InputLabel style={{ padding: '0.5rem' }}>Doenca</InputLabel>
                                        <Select
                                            fullWidth
                                            id="outlined-required"
                                            value={formValues.doenca_id}
                                            onChange={handleOptionChange}
                                            variant="outlined"
                                            displayEmpty
                                            style={{height: '40.1px'}} // adicione esta linha
                                        >

                                            <MenuItem value="">Selecione</MenuItem>
                                            {doencas.map(doenca => (
                                                <MenuItem key={doenca.id} value={doenca.id}>
                                                    {doenca.doenca}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </Grid>
                                </Grid>
                            </CardContent>
                            <CardActions>
                                <Button  variant="contained"id="success" type="submit">
                                    <i className="fa-solid fa-plus"></i> Salvar
                                </Button>
                            </CardActions>
                        </form>
                    </Card>
                </Grid>
            </Grid>
            <br />
            <br />
            <Card>
            <TabelaPacientes key={tableKey} /> {/* adiciona o componente Tabela com a key atualizada */}
        </Card>
        </main>
    );
};
export default Main;
